import * as React from "react";
import { observer } from "mobx-react";
import { WeddingDateFormItem } from "../molecules/WeddingDateFormItem";
import { MainNameFormItem } from "../molecules/MainNameFormItem";
import { SubNameFormItem } from "../molecules/SubNameFormItem";
import { NameRomanFormItem } from "../molecules/NameRomanFormItem";
import { PhoneNumberFormItem } from "../molecules/PhoneNumberFormItem";
import { PhoneNumber2FormItem } from "../molecules/PhoneNumber2FormItem";
import { EmailFormItem } from "../molecules/EmailFormItem";
import { Email2FormItem } from "../molecules/Email2FormItem";
import { useContext, useState } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Button, Form, Spin } from "antd";
import { RouteComponentProps } from "react-router-dom";
import { PostalCodeFormItem } from "../molecules/PostalCodeFormItem";
import { AddressFormItem } from "../molecules/AddressFormItem";
import { medium } from "../../style/button";
import { ReferralOptionFormItem } from "../molecules/ReferralOptionFormItem";
import { FixedFooter } from "../atoms/FixedFooter";
import { ArrowLink } from "../atoms/ArrowLink";
import { Footer } from "../organisms/Footer";
import { apiEndpoint } from "../../util";

export const ApplicationContact = observer(
  ({ history }: RouteComponentProps) => {
    const store = useContext(ContactViewStoreContext);

    const [loading, setLoading] = useState(false);

    // TODO: フォームを使う
    const [weddingDate] = useState(store.weddingDate);
    const [mainName] = useState(store.mainName);
    const [subName] = useState(store.subName);
    const [phoneNumber] = useState(store.phoneNumber);
    const [email] = useState(store.email);
    const [preferSMS] = useState(store.preferSMS);
    const [postalCode] = useState(store.postalCode);
    const [address] = useState(store.address);
    const [referralOption] = useState(store.referralOption);

    return (
      <div>
        <Form
          labelCol={{ xs: { span: 24 }, sm: { span: 8 } }}
          wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }}
        >
          <WeddingDateFormItem />
          <MainNameFormItem />
          <SubNameFormItem />
          <NameRomanFormItem />
          <PhoneNumberFormItem />
          <EmailFormItem />
          <PhoneNumber2FormItem />
          <Email2FormItem />
          <PostalCodeFormItem />
          <AddressFormItem />
          <ReferralOptionFormItem />
        </Form>

        <Footer />

        <FixedFooter>
          <button
            css={medium}
            disabled={loading}
            onClick={() => {
              if (!store.hasAdvancedContactInfo) {
                alert("すべての項目を埋めてください");
                return;
              }

              if (!store.hasValidEmail) {
                alert("メールアドレスの書式を確認してください");
                return;
              }

              setLoading(true);

              store
                .linkCredential()
                .then(_ => store.persist())
                .then(_ =>
                  fetch(apiEndpoint("/postal/orders"), {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify(store.toRequest("draft"))
                  })
                )
                .then(response => {
                  if (response.status >= 400) throw new Error("server error");
                  history.push("/application/order");
                  setLoading(false);
                })
                .catch(_ => {
                  alert("エラーが発生しました");
                  setLoading(false);
                });
            }}
          >
            OK
            {loading && <Spin size="small" />}
          </button>
          <ArrowLink
            onClick={e => {
              e.preventDefault();
              if (loading) return;
              // TODO: フォームを使う
              store.weddingDate = weddingDate;
              store.mainName = mainName;
              store.subName = subName;
              store.phoneNumber = phoneNumber;
              store.email = email;
              store.preferSMS = preferSMS;
              store.postalCode = postalCode;
              store.address = address;
              store.referralOption = referralOption;
              history.push("/application/order");
            }}
            to=""
            direction="left"
          />
        </FixedFooter>
      </div>
    );
  }
);
